import styled from 'styled-components';
import Collapse from 'antd/es/collapse';

export const StyledCollapse = styled(Collapse)`
  &.setur-collapse {
    width: 100%;
    height: auto;
    border: none;
    background-color: transparent !important;
  }

  & > .setur-collapse-item {
    border: none !important;
  }

  .setur-collapse-content-active {
    margin-top: 16px;
  }

  & .setur-collapse-content {
    border: none;
    background-color: transparent !important;
  }

  & .setur-collapse-content-box {
    padding: 0px !important;
    background-color: transparent !important;
  }

  & .setur-collapse-header {
    padding: 0px !important;
    margin: 0px !important;
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.eclipse};
    display: flex !important;
    justify-content: space-between;
    align-items: center !important;
    flex-direction: row;

    span {
      display: flex;
      position: relative !important;
      top: unset !important;
      right: unset !important;
      left: unset !important;
      -webkit-transform: unset !important;
      transform: unset !important;
    }

    .setur-collapse-expand-icon {
      padding-inline-start: 6px !important;
    }
  }
`;
